import { FC } from "react";

import { GenericUploadRowConflictError } from "@ryde/shared";

import { RowConflictsTable } from "./row-conflicts-table";
import { ValidationFailedTable } from "./validation-failed-table";

interface IResolveRowConflictsTableProps {
  errorType: GenericUploadRowConflictError;
}

export const ResolveRowConflictsTable: FC<IResolveRowConflictsTableProps> = ({
  errorType,
}) => {
  switch (errorType) {
    case GenericUploadRowConflictError.ValidationFailed: {
      return <ValidationFailedTable />;
    }

    default: {
      return <RowConflictsTable />;
    }
  }
};
